export default __webpack_public_path__ + "static/media/star-blue.8273ace9.svg";